// Triggers a Cylindo viewer's hidden ::part(fab) buttons from our own controls
const clickViewerControl = (viewerId, part) => {
  const viewer = document.getElementById(viewerId);
  viewer?.shadowRoot?.querySelector(`button[part~="${part}"]`)?.click();
};

// The QR panel is a <cylindo-ar> with its own shadow root nested inside the
// viewer's, so its close button is one level deeper than clickViewerControl
// reaches. Clicking it removes <cylindo-ar>, which is what useCylindoARActive
// watches for, so isARActive clears itself (CON-8444).
export const closeViewerAR = viewerId => {
  const viewer = document.getElementById(viewerId);
  const ar = viewer?.shadowRoot?.querySelector('cylindo-ar');
  ar?.shadowRoot?.querySelector('button[part~="qr-fab"]')?.click();
};

export default clickViewerControl;
